module.exports = __webpack_public_path__ + "static/media/ryde2.34b72337.jpg";